/**
 * pc-mock.js — PC 环境模拟实现
 * 职责：在 PC 浏览器中模拟原生桥接行为，支持开发调试
 */

import { updateStore } from './platform'

/** PC 模拟数据 — 虚拟蓝牙设备 */
export const MOCK_DEVICES = [
  { name: 'MVCI_01_02575', address: 'AA:BB:CC:DD:EE:01', state: 'disconnected' },
  { name: 'MVCI_02_01832', address: 'AA:BB:CC:DD:EE:02', state: 'disconnected' },
  { name: 'MVCI_03_04291', address: 'AA:BB:CC:DD:EE:03', state: 'disconnected' }
]

/** 当前模拟已连接的设备 */
export let mockConnectedDevice = null

/** 重置模拟连接状态 */
export function resetMockConnectedDevice() {
  mockConnectedDevice = null
}

/** 模拟：打开蓝牙 */
export function pcOpenBT() {
  console.log('[PC模拟] 打开蓝牙')
  return new Promise((resolve) => {
    setTimeout(() => {
      updateStore('updateBTState', 'opened')
      resolve({ code: '00', msg: '蓝牙已打开(PC模拟)' })
    }, 500)
  })
}

/** 模拟：连接蓝牙设备 */
export function pcConnectDevice(device) {
  console.log('[PC模拟] 连接设备:', device.name)
  return new Promise((resolve) => {
    setTimeout(() => {
      if (Math.random() > 0.7) {
        const reason = `无法与"MVCI：${device.name}"连接，可能原因如下：</br>1.该设备蓝牙关闭，或不在通信范围内（10米）；</br>2.该设备已经与其他设备连接，请断开后重试。`
        updateStore('updateFailReason', reason)
        updateStore('updateError', '3')
        resolve({ code: '3', msg: '连接失败(PC模拟)' })
      } else {
        mockConnectedDevice = { ...device, state: 'connected' }
        updateStore('updateConnectFlag', 1)
        updateStore('updateDeviceStatus', 'online')
        updateStore('updateDevice', mockConnectedDevice)
        updateStore('updateError', 0)
        setTimeout(() => {
          updateStore('updateVin', 'LSGGH59L9DS007027')
          updateStore('VINCompleteFlag', 1)
        }, 2000)
        resolve({ code: '00', device: mockConnectedDevice })
      }
    }, 1500)
  })
}

/** 模拟：断开蓝牙设备 */
export function pcDisconnectDevice() {
  mockConnectedDevice = null
  updateStore('updateConnectFlag', 0)
  updateStore('updateDeviceStatus', 'unline')
  updateStore('updateDevice', null)
  updateStore('updateVin', '')
  updateStore('VINCompleteFlag', 0)
  console.log('[PC模拟] 断开连接')
  return Promise.resolve({ code: '00', msg: '已断开(PC模拟)' })
}

/** 模拟：获取蓝牙设备列表 */
export function pcListBTItems() {
  console.log('[PC模拟] 搜索蓝牙设备')
  return new Promise((resolve) => {
    setTimeout(() => {
      const devices = MOCK_DEVICES.map(d => ({
        ...d,
        state: (mockConnectedDevice && mockConnectedDevice.address === d.address)
          ? 'connected' : 'disconnected'
      }))
      resolve({
        code: '00',
        result: '00',
        data: JSON.stringify(devices),
        msg: '搜索完成(PC模拟)'
      })
    }, 1000)
  })
}

/** 模拟：通用 callHandler */
export function pcCallHandler(name, data, callback) {
  console.log('[PC模拟] callHandler:', name, data)
  setTimeout(() => {
    if (callback) callback({ code: '00', msg: 'PC模拟响应' })
  }, 300)
}

/** 模拟：通用 registerHandler */
export function pcRegisterHandler(name) {
  console.log('[PC模拟] registerHandler:', name)
}

/** 模拟：监听蓝牙状态（空实现，仅打印日志） */
export function pcWatchBtstate() {
  console.log('[PC模拟] 监听蓝牙状态')
}

/** 模拟：监听蓝牙连接状态（空实现，仅打印日志） */
export function pcWatchBTStatus() {
  console.log('[PC模拟] 监听蓝牙连接状态')
}

/** 模拟：监听 VIN 读取完成（空实现，仅打印日志） */
export function pcWatchVIN() {
  console.log('[PC模拟] 监听VIN读取')
}

/** 模拟：获取位置信息 */
export function pcGetLocation() {
  updateStore('updateLocation', '121.4737,31.2304')
}

/** 模拟：获取用户信息 */
export function pcGetUserInfo() {
  const mockUser = { userId: 'test001', userName: '测试用户', dealerCode: 'TEST01' }
  updateStore('updateUserInfo', JSON.stringify(mockUser))
}

/** 模拟：获取位置权限 */
export function pcGetLocationAuth() {
  return Promise.resolve({ granted: true })
}

/** 模拟：上传信息 */
export function pcUploadInfo(data) {
  console.log('[PC模拟] 上传信息:', data)
  return Promise.resolve({ code: '00', msg: '上传成功(PC模拟)' })
}

/** 模拟：设置里程 */
export function pcSetMileage(mileage) {
  updateStore('updateSetMileage', mileage)
  return Promise.resolve({ code: '00', value: mileage })
}

/** 模拟：获取 MVCI 列表 */
export function pcGET_MVCI_LIST() {
  updateStore('UPDATE_MVCI_LIST', MOCK_DEVICES)
  return Promise.resolve(MOCK_DEVICES)
}

/** 模拟：添加服务数据 */
export function pcADD_SERVICE_DATA(data) {
  console.log('[PC模拟] 添加服务数据:', data)
  return Promise.resolve({ code: '00' })
}
